import {
  DEFAULT_LOGIN_FLOW_VARIANT,
  DialectsEnum,
  LangEnum,
  OSFamilyEnum,
} from "@/constants/constants";
import { API_ROUTES } from "../apiRoutes";
import { REQUEST_METHODS } from "../configs.apiClient";
import { HttpClient } from "../HttpClient";

import * as SettingInterfaces from "@/types/setting.types";
import { Culture, DialectsRes } from "@/types/setting.types";
import { captureError, getPlanId } from "@/utils/common.helpers";

export class SettingAPIClient {
  private httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  async copies(
    lang?: string,
    planId?: string,
    loginFlowVariant = DEFAULT_LOGIN_FLOW_VARIANT,
  ) {
    try {
      const method = REQUEST_METHODS.GET;
      const endpoint = API_ROUTES.setting.copies;

      const queryParams = {
        tnplPlanId: planId ?? (await getPlanId({ isTrial: true })),
        isRecurringSubscriptionBuild: true,
        isTrialSubscriptionBuildUser: true,
        appId: "in.stage",
        loginFlowVariant,
      };

      const response =
        await this.httpClient.request<SettingInterfaces.CopiesInterface>({
          endpoint,
          options: {
            method,
          },
          addToken: false,
          lang,
          dialect: DialectsEnum.HARYANVI,
          queryParams,
        });

      return response?.data;
    } catch (error) {
      console.error("Error in SettingAPIClient copies", error);

      throw new Error("Error in SettingAPIClient copies");
    }
  }

  async getDialect(): Promise<SettingInterfaces.Dialect[]> {
    try {
      const method = REQUEST_METHODS.GET;
      const endpoint = API_ROUTES.setting.getDialects;

      const response = await this.httpClient.request<DialectsRes>({
        endpoint,
        options: {
          method,
        },
        queryParams: {
          os: OSFamilyEnum.ANDROID,
        },
        dialect: DialectsEnum.HARYANVI,
        lang: LangEnum.EN,
        addToken: false,
      });

      return response?.data.dialectListing.map((_dialect) => ({
        ..._dialect,
        urlValue: _dialect.dialect.toLocaleLowerCase(),
      }));
    } catch (error) {
      console.error("Error in SettingAPIClient getDialect", error);
      throw captureError(error);
    }
  }

  async getCultures({
    dialect,
    lang,
  }: {
    dialect: string;
    lang: string;
  }): Promise<SettingInterfaces.Culture[]> {
    try {
      const method = REQUEST_METHODS.GET;
      const endpoint = API_ROUTES.setting.getCultures;

      const response = await this.httpClient.nestRequest<Culture[]>({
        endpoint,
        options: {
          method,
          headers: {
            os: OSFamilyEnum.ANDROID,
          },
        },
        dialect,
        lang,
        addToken: false,
      });

      return response;
    } catch (error) {
      console.error("Error in SettingAPIClient getCultures", error);
      throw captureError(error);
    }
  }
}
